<script>
    import "./util/GlobalStyles.svelte";
    import Router from 'svelte-spa-router'

    import Landing from './Landing.svelte';
    import Menu from './Menu.svelte';
    import Sequencer from './Sequencer.svelte';
    import MouthfeelTuner from './MouthfeelTuner.svelte';
    import Respeller from './Respeller.svelte';
    import WordExplorer from './WordExplorer.svelte';
    import WordMixer from './WordMixer.svelte';
    import LoadingPincelate from './util/LoadingPincelate.svelte';
    
    import GACFooter from './GACFooter.svelte';

    const routes = {
        '/': Landing,
        '/menu': Menu,
        '/sequencer': Sequencer,
        '/mouthfeel': MouthfeelTuner,
        '/respeller': Respeller,
        '/explorer': WordExplorer,
        '/mixer': WordMixer,
        '/loading': LoadingPincelate
    }

</script>

<Router {routes}/>

<GACFooter/>